<template lang="html">
	<div class="stock" :class="{'stock--single': singleView}">
		<swiper class="stock__body stock__slider swiper-container" :space-between="10" :speed="700" :autoplay="{delay: 5000}" :slides-per-view="1" :loop="promoData.length > 1" :breakpoints="breakpoints" :modules="modules" :pagination="paginationOptions" :touchEventsTarget="'container'" @swiper="onSwiper" v-custom-cursor="'.custom-cursor'">
			<template #container-start>
				<div class="custom-cursor"><span>Потянуть</span></div>
			</template>

			<swiper-slide
                v-for="promoItem in promoData"
                :key="promoItem.id"
                class="swiper-slide"

                :href="promoItem.url || false"
                :target="promoItem.url ? '_blank' : false"
            >
				<div v-if="promoItem.videoSrc" class="stock__video">
					<video controls style="width: 100%" :poster="promoItem.imgSrc" >
						<source :src="promoItem.videoSrc">
					</video>
				</div>
				<div v-else-if="promoItem.imgSrc" class="stock__image">
                    <img :src="promoItem.imgSrc" loading="lazy"/>
                    <a :href="promoItem.url" class="block-link cursor-none"/>
				</div>
				<div class="stock__info" data-default-cursor>
					<div v-if="promoItem.name" class="stock__title" v-html="promoItem.name"></div>
					<div v-if="promoItem.text" class="stock__text" v-html="promoItem.text"></div>
				</div>
			</swiper-slide>

			<template #container-end>
				<div class="stock__slider-pagination swiper-pagination"></div>
			</template>
		</swiper>
	</div>
</template>

<script>

import {Swiper, SwiperSlide} from 'swiper/vue';
import {Pagination} from "swiper";

export default {
	name: 'CatalogStock',
	components: {
		Swiper,
		SwiperSlide,
	},
	props: {
		promoData: {
			type: Array,
			default: () => [],
		},
        singleView: {
            type: Boolean,
            default: false,
        }
	},
	setup() {
		const onSwiper = (swiper) => {
			swiper.update()
		}

		const paginationOptions = {
			el: '.stock__slider-pagination',
			type: "fraction",
			formatFractionCurrent: (number) => number < 10 ? '0' + number : number,
			formatFractionTotal: (number) => number < 10 ? '0' + number : number,
			renderFraction: (currentClass, totalClass) => '<span class="' + currentClass + '"></span><span class="' + totalClass + '"></span>',
		};

		const breakpoints = {
			1280: {
				spaceBetween: 40
			},
			768: {
				spaceBetween: 20
			},
			520: {
				spaceBetween: 20
			},
		}


		return {
			modules: [Pagination],
			paginationOptions,
			breakpoints,
			onSwiper,
		};
	},
}

</script>


<style scoped>
.swiper-wrapper{
	will-change: transform;
}
.swiper-slide-active {
	pointer-events: auto;
}
</style>
